module.exports = __webpack_public_path__ + "static/media/demo.a1dbd792.jpg";